<template>
  <template v-if="authStore.loading">
    <AppContentLoader />
  </template>

  <template v-else>
    <div class="flex flex-col h-full min-h-fit">
      <AppNavbar v-if="authStore.isAuthenticated && showNavbar" />

      <RouterView />

      <Teleport to="body">
        <div class="toast-container">
          <TransitionGroup name="slide-fade">
            <ToastMessage
              v-for="toast in toastStore.toasts"
              :key="toast.id"
              :message="toast.message"
              :type="toast.type"
              @dismissed="toastStore.remove(toast.id)"
            />
          </TransitionGroup>
        </div>
      </Teleport>

      <AppFooter v-if="showFooter" />
    </div>
  </template>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import {
  AppContentLoader,
  AppFooter,
  AppNavbar,
} from '@/components/app/index.js';
import { ToastMessage } from '@/components/toasts/index.js';

import { useAuthStore, useToastStore } from '@/store/index.js';

const authStore = useAuthStore();
const toastStore = useToastStore();

const route = useRoute();
const router = useRouter();

const showNavbar = computed(() => route.meta.showNavbar ?? true);
const showFooter = computed(() => route.meta.showFooter ?? true);

if (route.path === '/') {
  router.push({ name: 'app_default' });
}

</script>

<style>
body {margin: 0 0 0 0 !important;}
</style>

<style scoped>
.fade.show {
  display: flex !important;
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: transform 0.5s ease-out, opacity 0.5s ease-out;
}

.slide-fade-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
</style>
